// extracted by mini-css-extract-plugin
export var card = "_m8-0";
export var content = "_m8-2";
export var details = "_m8-3";
export var icon = "_m8-1";
export var iconBlue = "_m8-5";
export var iconBrand = "_m8-4";
export var iconGrayBlue = "_m8-6";
export var iconGreen = "_m8-7";
export var iconIndigo = "_m8-8";
export var iconOrange = "_m8-9";
export var iconPurple = "_m8-a";
export var iconRed = "_m8-b";
export var iconWarning = "_m8-c";